import "./css/style.css"
import {toastr} from "react-redux-toastr"

import getMessage from "../lang/helpers/getMessage"

export const success = (cfg = {}) => {
  const {title = "Success", message = "", ...options} = cfg
  toastr.success(title, message, options)
}

export const info = (cfg = {}) => {
  const {title = "Note", message = "", ...options} = cfg
  toastr.info(title, message, options)
}

export const warning = (cfg = {}) => {
  const {title = "Warning", message = "", ...options} = cfg
  toastr.info(title, message, options)
}

export const error = (cfg = {}, componentThis = null) => {
  const {title = "Error", message = "", ...options} = cfg
  const formattedMessage = componentThis ? getMessage(componentThis, message) : message
  toastr.error(title, formattedMessage, options)
}

export const light = (cfg = {}, componentThis = null) => {
  const {title = "", message = "", ...options} = cfg
  const formattedMessage = componentThis ? getMessage(componentThis, message) : message
  toastr.light(title, formattedMessage, {className: "toastr-light-no-icon", ...options})
}

export default {success, info, warning, error, light}
